<template>
  <div class="overlay">
    <div class="filter-sidebar">
      <div class="close-sidebar" @click="onClose">
        <i class="fa fa-times close-icon"/>
        ปิด
      </div>
      <div class="filter-container">
        <div class="title">
          <i class="fa fa-filter mr-2" />
          <h5 class="m-0">ค้นหาขั้นสูง</h5>
        </div>
        <FormGroup class="filter-item" v-if="isFilterEnabled('status')">
          <h5 class="name">สถานะ</h5>
          <div>
            <select class="form-control" @change="onSelectedStatus" v-model="contentFilter.status">
              <option value="any">ทั้งหมด</option>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
              <option value="scheduled">Scheduled</option>
            </select>
          </div>
        </FormGroup>
        <div class="filter-item" v-if="isFilterEnabled('contentCategories')">
          <div>หมวดหมู่ของคอนเทนท์</div>
          <SelectOption
            :value="contentFilter.contentCategoryId"
            :options="contentCategories"
            :customLabel="'name'"
            @onChanged="onSelectedContentCategory"
          />
        </div>
        <div class="filter-item" v-if="isFilterEnabled('videoCategories')">
          <div>หมวดหมู่ของวิดีโอ</div>
          <SelectOption
            :value="contentFilter.categoryId"
            :options="videoCategories"
            :customLabel="'name'"
            @onChanged="onSelectedVideoCategory"
          />
        </div>
        <div class="filter-item" v-if="isFilterEnabled('program')">
          <div>รายการ</div>
          <SelectOptionObject
            :value="filterInformation.program"
            :options="programs"
            :label="'title'"
            :placeholder="'เลือกรายการ'"
            @onChanged="onSelectedProgram"
            @onSearch="loadPrograms"
          />
        </div>
        <div class="filter-item" v-if="isFilterEnabled('episode')">
          <div>ตอน</div>
          <SelectOptionObject
            :value="filterInformation.episode"
            :options="episodes"
            :label="'title'"
            :placeholder="'เลือกตอน'"
            @onChanged="onSelectedEpisode"
            @onSearch="loadEpisodes"
          />
        </div>
        <div class="filter-item" v-if="isFilterEnabled('age')">
          <div>ช่วงอายุ</div>
          <SelectOption
            :value="contentFilter.ageCategoryId"
            :options="ageCategories"
            :customLabel="'name'"
            :placeholder="'เลือกช่วงอายุ'"
            :removeable="false"
            @onChanged="onSelectedAgeCategory"
          />
        </div>
        <div class="filter-item" v-if="isFilterEnabled('subject')">
          <div>รายวิชา</div>
          <SelectOption
            :value="contentFilter.subjectCategoryId"
            :options="subjectCategories"
            :customLabel="'name'"
            :placeholder="'เลือกรายวิชา'"
            :removeable="false"
            @onChanged="onSelectedSubjectCategory"
          />
        </div>
        <button class="btn btn-link btn-sm clear-button" type="button" @click="clearSearch">
          ล้างการค้นหา
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { loadProgramByKey } from '@/program/api';
import { loadEpisodeById } from '@/episode/api';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import SelectOption from '@/components/SelectOption.vue';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    enableFilterOption: {
      type: Array,
      default: () => ['episode', 'program', 'videoCategories', 'contentCategories', 'status'],
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    onSearchEpisode: {
      type: Function,
      default: () => {},
    },
    onSearchProgram: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    SelectOption,
    SelectOptionObject,
    FormGroup,
  },
  data() {
    return {
      isToggle: true,
      filterInformation: {
        program: null,
        episode: null,
      },
      videoCategories: [],
      contentCategories: [],
      ageCategories: [],
      subjectCategories: [],
    };
  },
  computed: {
    ...mapState({
      contentFilter: (state) => state.filter.filter,
      episodes: (state) => state.episodesList.episodes,
      programs: (state) => state.programsList.programs,
    }),
    filter() {
      return this.$route.query;
    },
    programId() {
      return this.$route.query.programId;
    },
    episodeId() {
      return this.$route.query.episodeId;
    },
  },
  // watch: {
  //   // programId(newId) {
  //   //   if (this.contentFilter.programId === newId) return;
  //   //   this.loadSelectedProgram(this.programId);
  //   // },
  //   // episodeId(newId) {
  //   //   if (this.contentFilter.episodeId === newId) return;
  //   //   this.loadSelectedEpisode(this.episodeId);
  //   // },
  // },
  created() {
    this.load();
    document.body.classList.add('sidebar-open');
  },
  beforeDestroy() {
    document.body.classList.remove('sidebar-open');
  },
  methods: {
    load() {
      if (this.contentFilter.programId) {
        this.loadSelectedProgram(this.programId);
      }
      if (this.contentFilter.episodeId) {
        this.loadSelectedEpisode(this.episodeId);
      }
      if (this.isFilterEnabled('program')) {
        this.loadPrograms();
      }
      if (this.isFilterEnabled('episode')) {
        this.loadEpisodes();
      }
      if (this.isFilterEnabled('videoCategories')) {
        this.loadVideoCategories();
      }
      if (this.isFilterEnabled('contentCategories')) {
        this.loadContentCategories();
      }
      if (this.isFilterEnabled('age')) {
        this.loadAgeCategories();
      }
      if (this.isFilterEnabled('subject')) {
        this.loadSubjectCategories();
      }
      this.$store.dispatch('setFilterState', this.filter);
    },
    async loadPrograms(filter) {
      if (this.filter || (this.programs && this.programs.length === 0)) {
        await this.$store.dispatch('loadProgramsList', filter);
      }
    },
    async loadEpisodes(filter) {
      if (this.filter || (this.episodes && this.episodes.length === 0)) {
        this.$store.dispatch('loadEpisodesList', filter);
      }
    },
    async loadVideoCategories() {
      const response = await loadTaxonomyByKey('video-category');
      this.videoCategories = response.data.data;
    },
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategories = response.data.data;
    },
    async loadAgeCategories() {
      const response = await loadTaxonomyByKey('age-category');
      this.ageCategories = response.data.data;
    },
    async loadSubjectCategories() {
      const response = await loadTaxonomyByKey('subject-category');
      this.subjectCategories = response.data.data;
    },
    async loadSelectedEpisode(episodeId) {
      if (!episodeId) {
        this.filterInformation.episode = null;
        return;
      }
      const response = await loadEpisodeById(episodeId);
      this.filterInformation.episode = response.data;
    },
    async loadSelectedProgram(programId) {
      if (!programId) {
        this.filterInformation.program = null;
        return;
      }
      const response = await loadProgramByKey(programId);
      this.filterInformation.program = response.data;
    },
    clearSearch() {
      this.$store.dispatch('clearFilter');
      this.$router.push({ query: null });
      this.filterInformation = { episode: null, program: null };
    },
    onSelectedProgram(program) {
      const programId = _.get(program, 'id', null);
      this.$store.dispatch('setFilterState', { programId });
      this.pushQueryToRoute();
      this.filterInformation.program = program;
    },
    onSelectedEpisode(episode) {
      const episodeId = _.get(episode, 'id', null);
      this.$store.dispatch('setFilterState', { episodeId });
      this.pushQueryToRoute();
      this.filterInformation.episode = episode;
    },
    onSelectedVideoCategory(categoryId) {
      this.$store.dispatch('setFilterState', { categoryId });
      this.pushQueryToRoute();
    },
    onSelectedContentCategory(contentCategoryId) {
      this.$store.dispatch('setFilterState', { contentCategoryId });
      this.pushQueryToRoute();
    },
    onSelectedAgeCategory(ageCategoryId) {
      this.$store.dispatch('setFilterState', { ageCategoryId });
      this.pushQueryToRoute();
    },
    onSelectedSubjectCategory(subjectCategoryId) {
      this.$store.dispatch('setFilterState', { subjectCategoryId });
      this.pushQueryToRoute();
    },
    onSelectedStatus(event) {
      const status = event.target.value;
      this.$store.dispatch('setFilterState', { status });
      this.pushQueryToRoute();
    },
    isFilterEnabled(filter) {
      return this.enableFilterOption.includes(filter);
    },
    pushQueryToRoute() {
      if (!_.isEqual(this.$route.query, this.contentFilter)) {
        this.$router.push({ query: this.contentFilter });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';

select.form-control {
  padding: 8px 0px 0 10px;
  min-height: 40px;
}

.filter-sidebar {
  position: fixed;
  width: 250px;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f8f9fa;
  z-index: 1000;
  transition: all 0.2s;
  .close-sidebar {
    cursor: pointer;
    border-bottom: 0.5px solid $gray-400;
    .close-icon {
      padding: $spacer;
    }
  }
  .filter-container {
    padding: $spacer;
    margin-top: $spacer * 1.25;
    .filter-item{
      margin-bottom: $spacer * 1.5;
      flex: 0 0 250px;
    }
    .clear-button {
      margin-top: $spacer / 1.5;
      padding: 0;
      float: right;
    }
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: $spacer * 2.5;
  }
}

@media (max-width: 575.98px) {
  .overlay {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .filter-sidebar {
    width: 70%;
    max-width: 250px;
    .filter-container {
      margin: 0;
      overflow: auto;
      height: 80vh;
    }
    .title {
      margin-top: $spacer;
      margin-bottom: $spacer * 2.5;
    }
  }
}
</style>
